import { BoxProps } from '@chakra-ui/react'
import React, { createContext } from 'react'

import { PageContent } from '@/containers/PageContent'

interface StepsContentProps extends BoxProps {
  step: number
  children: React.ReactNode
}

export type StepsContextData = {
  step: number,
}

export const stepsContext = createContext<StepsContextData>({ step: 1 })

export const StepsContent = ({ step, children }: StepsContentProps) => {
  return (
    <stepsContext.Provider value={{ step: step }}>
      <PageContent sx={{ display: 'grid', gap: 8, alignItems: 'start' }}>
        {children}
      </PageContent>
    </stepsContext.Provider>
  )
}